/**
   * Service Fee — automatisch toevoegen / verwijderen.
   */
  (function () {
    var SERVICE_FEE_VARIANT_ID = '57274962870616';
    var SERVICE_FEE_VARIANT_ID_NUM = 57274962870616;
    var syncing = false;
    var syncQueued = false;

    function getCart() {
      return fetch('/cart.js').then(function (r) { return r.json(); });
    }

    function refreshCartUI() {
      // Cart drawer — alleen inner content vervangen, niet de hele drawer
      var drawerItems = document.getElementById('CartDrawer-CartItems');
      if (drawerItems) {
        fetch('/?section_id=cart-drawer')
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');

            // Update cart items
            var freshItems = doc.getElementById('CartDrawer-CartItems');
            if (freshItems) drawerItems.innerHTML = freshItems.innerHTML;

            // Update drawer footer
            var freshFooter = doc.querySelector('.drawer__footer');
            var currentFooter = document.querySelector('cart-drawer .drawer__footer');
            if (freshFooter && currentFooter) currentFooter.innerHTML = freshFooter.innerHTML;
          });
      }

      // Cart page items
      var cartItems = document.getElementById('main-cart-items');
      if (cartItems) {
        var sectionId = cartItems.dataset.id;
        fetch('/?section_id=' + sectionId)
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var fresh = doc.querySelector('.js-contents');
            var current = cartItems.querySelector('.js-contents');
            if (fresh && current) current.innerHTML = fresh.innerHTML;
          });
      }

      // Cart footer
      var cartFooter = document.getElementById('main-cart-footer');
      if (cartFooter) {
        var footerId = cartFooter.dataset.id;
        fetch('/?section_id=' + footerId)
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var fresh = doc.querySelector('.js-contents');
            var current = cartFooter.querySelector('.js-contents');
            if (fresh && current) current.innerHTML = fresh.innerHTML;
          });
      }

      // Cart icon bubble
      fetch('/?section_id=cart-icon-bubble')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('.shopify-section');
          var bubble = document.getElementById('cart-icon-bubble');
          if (fresh && bubble) bubble.innerHTML = fresh.innerHTML;
        });
    }

    function syncServiceFee() {
      if (syncing) {
        syncQueued = true;
        return Promise.resolve();
      }
      syncing = true;

      return getCart().then(function (cart) {
        var feeItem = cart.items.find(function (i) {
          return String(i.variant_id) === SERVICE_FEE_VARIANT_ID;
        });
        var otherItems = cart.items.filter(function (i) {
          return String(i.variant_id) !== SERVICE_FEE_VARIANT_ID;
        });

        if (otherItems.length > 0 && !feeItem) {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              items: [{ id: SERVICE_FEE_VARIANT_ID_NUM, quantity: 1 }],
            }),
          }).then(function () { refreshCartUI(); });
        }

        if (otherItems.length === 0 && feeItem) {
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: SERVICE_FEE_VARIANT_ID, quantity: 0 }),
          }).then(function () { refreshCartUI(); });
        }

        if (feeItem && feeItem.quantity !== 1) {
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: SERVICE_FEE_VARIANT_ID, quantity: 1 }),
          }).then(function () { refreshCartUI(); });
        }
      }).catch(function (e) {
        console.error('[service-fee]', e);
      }).then(function () {
        syncing = false;
        if (syncQueued) {
          syncQueued = false;
          return syncServiceFee();
        }
      });
    }

    var debounceTimer;
    function debouncedSync() {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(syncServiceFee, 300);
    }

    // ── Init ──────────────────────────────────────────────────────────────
    document.addEventListener('DOMContentLoaded', function () {
      syncServiceFee();

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, debouncedSync);
      }
    });

    // ── Fetch interceptor ─────────────────────────────────────────────────
    var originalFetch = window.fetch;
    window.fetch = function () {
      var url = arguments[0];
      var result = originalFetch.apply(this, arguments);

      if (typeof url === 'string' &&
          (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update')) &&
          !url.includes(SERVICE_FEE_VARIANT_ID)) {
        result.then(function () { debouncedSync(); }).catch(function () {});
      }

      return result;
    };
  })();